module.exports = __webpack_public_path__ + "img/fifa-20.76b242c9.png";